import { accordionDetailsClasses, collapseClasses, styled } from "@mui/material";

import { Accordion } from "ui/Accordion";

/**
 * An Accordion that participates in flex layout by propagating a definite height
 * through the internal Collapse wrapper layers, so children like AgGrid
 * (domLayout: "normal") receive a concrete height for scrolling.
 */
export const FlexAccordion = styled(Accordion)`
  display: flex;
  flex-direction: column;

  &.Mui-expanded {
    flex: 1;
    min-height: 0;
  }

  & .${collapseClasses.entered} {
    flex: 1;
    min-height: 0 !important;
    display: flex;
    flex-direction: column;
    transition: none;
  }

  & .${collapseClasses.wrapper} {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
  }

  & .${collapseClasses.wrapperInner} {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
  }

  & [role="region"] {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
  }

  & .${accordionDetailsClasses.root} {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
  }
`;
